import axios from 'axios';

export const fetchUserData = async (token) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/mydata`, {
            headers: {
                Authorization: `Bearer ${token}`, // JWT 토큰 전달
            },
        });
        return response.data; // 사용자 데이터 반환
    } catch (error) {
        console.error('Failed to fetch user data:', error);
        throw error;
    }
};
